import { useEffect, useState } from "react";
import { fetchTasks, updateTask } from "@/lib/api";
import { TASKS } from "@/constants/testIds";
import { formatDate, classFor } from "@/lib/format";
import { Check, ClipboardList } from "lucide-react";
import { toast } from "sonner";

export default function TasksPage() {
  const [tasks, setTasks] = useState([]);
  const [view, setView] = useState("open");
  const load = () => fetchTasks().then(setTasks);
  useEffect(() => { load(); }, []);

  const toggle = async (t) => { await updateTask(t.id, !t.completed); toast.success(!t.completed ? "Marked done" : "Reopened"); load(); };

  const filtered = tasks.filter(t => view === "all" ? true : view === "open" ? !t.completed : t.completed);
  const groups = filtered.reduce((acc, t) => { const k = t.child_name || "Family"; (acc[k] ||= []).push(t); return acc; }, {});

  return (
    <div data-testid={TASKS.page} className="space-y-8">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <p className="label-overline">Tasks</p>
          <h1 className="font-display text-4xl text-[var(--fcc-ink)] mt-2">What needs your hands</h1>
        </div>
        <div className="flex gap-1 bg-white border border-[var(--fcc-border)] rounded-xl p-1 text-sm">
          {[{k:"open",l:"Open"},{k:"all",l:"All"},{k:"done",l:"Completed"}].map(o => (
            <button key={o.k} onClick={() => setView(o.k)} className={`px-3 py-1.5 rounded-lg ${view === o.k ? "bg-[var(--fcc-ink)] text-white" : "text-[var(--fcc-ink-soft)]"}`}>{o.l}</button>
          ))}
        </div>
      </div>

      {Object.keys(groups).length === 0 && (
        <div className="fcc-card p-10 text-center text-[var(--fcc-muted)]"><ClipboardList className="w-6 h-6 mx-auto" /><p className="mt-2">Nothing here right now.</p></div>
      )}

      {Object.entries(groups).map(([child, list]) => (
        <section key={child}>
          <h2 className="font-display text-2xl text-[var(--fcc-ink)] mb-4">{child}</h2>
          <ul className="space-y-3">
            {list.map(t => (
              <li key={t.id} className="fcc-card p-5 flex gap-4 items-start">
                <button data-testid={TASKS.toggle} onClick={() => toggle(t)} className={`w-6 h-6 rounded-full border-2 flex items-center justify-center mt-0.5 shrink-0 ${t.completed ? "bg-[var(--fcc-green)] border-[var(--fcc-green)]" : "border-[var(--fcc-green)]"}`}>
                  {t.completed && <Check className="w-3.5 h-3.5 text-white" />}
                </button>
                <div className="flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <p className={`font-semibold leading-snug ${t.completed ? "line-through text-[var(--fcc-muted)]" : "text-[var(--fcc-ink)]"}`}>{t.title}</p>
                    <span className={`fcc-pill ${classFor(t.priority)}`}>{t.priority}</span>
                  </div>
                  <p className="text-sm text-[var(--fcc-ink-soft)] mt-1">{t.description}</p>
                  <p className="text-[11px] uppercase tracking-widest mt-2 text-[var(--fcc-muted)]">{t.category} · Due {t.due_date ? formatDate(t.due_date) : "—"}</p>
                </div>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
